export enum MilestoneType {
    Directorate = 1,
    Project = 2,
    PartnerOrganisation = 3
}